import instance from "./axios";
import baseUrl from "@/env";
//根据id获取学生详情，传id则查询对应的学生，否则查当前登录人
// export async function studentDetail(data) {
//   const res = await instance.post(`${baseUrl}/student/detail`, data);
//   return res.data;
// }
export async function studentDetail(data) {
  const res = await instance.post(`${baseUrl}/student/detail?id=${data}`);
  return res.data;
}

//获取试卷剩余时间
export async function getRemainById(data) {
  const res = await instance.get(
    `${baseUrl}/examinationinfo/getRemainById/${data}`
  );
  return res.data;
}
//获取个人信息
//cc
export async function getStudentInfo(data) {
  const res = await instance.get(`${baseUrl}/student/getStudentInfo`, data);
  return res.data;
}

export async function getLastUserExamResults(data) {
  const params = typeof data === "object" ? data : { limnumber: data };
  const limnumber = params.limnumber || 100;
  const examName = params.examName || "";
  const res = await instance.get(
    `${baseUrl}/userResult/getLastUserExamResults?limnumber=${limnumber}&examName=${encodeURIComponent(
      examName
    )}`
  );
  return res.data;
}

// 学生考试记录统计
export async function getStudentExamStatistics(examSerList) {
  const payload = Array.isArray(examSerList) ? examSerList : [];
  const res = await instance.post(
    `${baseUrl}/exam/statistics/student`,
    payload
  );
  return res.data;
}
//扫码登录
export async function getScanQrCde(data) {
  const res = await instance.post(
    `${baseUrl}/scan/getScanQrCode?uid=${data.uid}`
  );
  return res.data;
}

//APP扫码提交
export async function subScanQrCode(data) {
  const res = await instance.post(
    `${baseUrl}/scan/subScanQrCode?uid=${data.uid}`
  );
  return res.data;
}
//获取时间
export async function getTimes() {
  const res = await instance.get(`${baseUrl}/version/systemTime`);
  return res;
}

//获取ip
export async function getIp() {
  const res = await instance.get(`${baseUrl}/version/getIp`);
  return res;
}
//获取学生当天考试试卷
export async function getStudentExaminationList() {
  const res = await instance.get(
    `${baseUrl}/examinationinfo/getStudentFutureExam`
  );
  return res.data;
}
//根据考试id获取试卷信息
export async function getExaminationInfoById(data) {
  const res = await instance.post(
    `${baseUrl}/examinationinfo/getExaminationInfoById?id=${data.id}`
  );
  return res.data;
}
//管理系统考试提交
export async function subAnswer(data) {
  const res = await instance.post(`${baseUrl}/userResult/subAnswer`, data);
  return res.data;
}

//pc考试系统学生上传答题信息
export async function uploadAnswer(data) {
  const res = await instance.post(`${baseUrl}/userResult/uploadAnswer`, data);
  return res.data;
}
//获取学生试卷详情
export async function getUserDetail(data) {
  const res = await instance.get(
    `${baseUrl}/userResult/getUserPaperDetail?examSer=${data}`
  );
  return res.data;
}
//是否有考试
export async function hasExamination() {
  const res = await instance.get(`${baseUrl}/examinationinfo/hasExam`);
  return res.data;
}

//管理系统自测考试查询列表
export async function getPageList(data) {
  const res = await instance.post(
    `${baseUrl}/examinationSelfTest/getPageList?limit=${data.limit}&page=${data.page}&studentId=${data.studentId}`
  );
  return res.data;
}
//获取所有课程
export async function getCoursesAll(data) {
  const res = await instance.get(`${baseUrl}/mathcourses/getCoursesAll`, data);
  return res.data;
}

//获取课程对应的所有章节
export async function getChapterPageList(data) {
  const res = await instance.get(
    `${baseUrl}/mathchapter/getChapterList?coursesId=${data.coursesId}`
  );
  return res.data;
}
//上传学生考试状态
export async function pushStudentType(data) {
  const res = await instance.post(
    `${baseUrl}/paperManager/addExamOperationInfo?message=${data.message}&operateName=${data.operateName}&operateType=${data.operateType}&paperID=${data.paperID}&userID=${data.userID}`
  );
  return res.data;
}
//根据作业课程id查询所有知识点
export async function mathsGetMathsPageList(data) {
  const res = await instance.get(
    `${baseUrl}/maths/getMathsList?chapterID=${data.chapterID}&coursesId=${data.coursesId}`
  );
  return res.data;
}

//获取学生自测题目
export async function getStudentTestFunnyexamList(data) {
  const res = await instance.post(
    `${baseUrl}/mathchapter/getStudentTestFunnyexamList?coursesId=${data.coursesId}`
  );
  return res.data;
}

//获取自测题目信息
export async function getExaminationSelfTest(data) {
  const res = await instance.post(
    `${baseUrl}/examinationSelfTest/getExaminationSelfTest`,
    data
  );
  return res.data;
}

//提交自测
export async function examinationSelfTestSubmitJob(data) {
  const res = await instance.post(
    `${baseUrl}/examinationSelfTest/submitJob`,
    data
  );
  return res.data;
}
// //获取总的题目数量
// export async function getFunnyexamCountNum(data){
//    const res = await instance.get(`${baseUrl}/mathcourses/getFunnyexamCountNum`,data)
//    return res.data
// }
//根据章节,知识点去获取题目的临时数据
export async function getTempQuestionList(data) {
  const res = await instance.post(
    `${baseUrl}/courseManager/getTempQuestionList`,
    data
  );
  return res.data;
}
//根据章节,知识点去获取所有题目
export async function getQuestionCountList(data) {
  const res = await instance.post(
    `${baseUrl}/courseManager/getQuestionCountList`,
    data
  );
  return res.data;
}
//通过题目的id数组去获取题目的信息
export async function getQuestionsByIds(data) {
  const res = await instance.post(
    `${baseUrl}/courseManager/getQuestionsByIds`,
    data
  );
  return res.data;
}

//修改密码
export async function changePwd(data) {
  const res = await instance.post(`${baseUrl}/student/studentForget`, data);
  return res.data;
}

//修改电话号码
export async function sendPhone(data) {
  const res = await instance.get(
    `${baseUrl}/student/modifyStudentPhone?code=${data.code}&phone=${data.phone}`,
    data
  );
  return res.data;
}
//修改学号
export async function sendStudentno(data) {
  const res = await instance.get(
    `${baseUrl}/student/modifyStudentNumber?code=${data.code}&newstudentno=${data.newstudentno}&phone=${data.phone}`,
    data
  );
  return res.data;
}
//修改学生密码

export async function changepwd(data) {
  const res = await instance.get(
    `${baseUrl}/student/modifyStudentPassword?code=${data.code}&password=${data.password}&phone=${data.phone}`,
    data
  );
  return res.data;
}

//获取提取码试卷
export async function getJoinCode(data) {
  const res = await instance.post(
    `${baseUrl}/examinationinfo/getExaminationInfoByJoinCode?joinCode=${data.joinCode}&localIp=${data.localIp}`,
    data
  );
  return res.data;
}
//根据id获取试卷
export async function getExaminationID(data) {
  const res = await instance.post(
    `${baseUrl}/examinationinfo/getExaminationInfoQuestions?paperId=${data.paperId}&localIp=${data.localIp}`,
    data
  );
  return res.data;
}
//获取用户答案记录
export async function getUserResultsById(data) {
  const res = await instance.post(
    `${baseUrl}/userResult/getUserResultsById?examinationSer=${data.examinationSer}`
  );
  return res.data;
}
// export async function getTaskPageList(data) {
//   const res = await instance.post(
//     `${baseUrl}/taskclass/getClassTaskPageList?limit=${data.limit}&page=${data.page}&sutdentId=${data.sutdentId}&taskType=${data.taskType}`,
//     data
//   );
//   return res.data;
// }
export async function getOwnTaskList(data) {
  const res = await instance.get(
    `${baseUrl}/teachingTask/getOwnTeachingTaskList?studentId=${data.studentId}&type=${data.type}`
  );
  return res.data;
}
export async function gteTaskStudentInfo(data) {
  const res = await instance.post(
    `${baseUrl}/taskstudent/gteTaskStudentInfo?taskStudentId=${data}`
  );
  return res.data;
}
export async function submitTask(data) {
  const res = await instance.post(`${baseUrl}/taskstudent/submitTask`, data);
  return res.data;
}
//学生获取任务详情
export async function getOwnTeachingTaskDetail(data) {
  const res = await instance.get(
    `${baseUrl}/teachingTask/getOwnTeachingTaskDetail?studentId=${data.studentId}&taskId=${data.taskId}`
  );
  return res.data;
}
//学生提交作业练习测验
export async function submitTeachingTask(data) {
  const res = await instance.post(
    `${baseUrl}/teachingTask/submitTeachingTask`,
    data
  );
  return res.data;
}
//学生获取考试试卷
export async function getStudentExaming() {
  const res = await instance.get(
    `${baseUrl}/examinationinfo/getStudentFutureExam`
  );
  return res.data;
}
//设置学生邮箱
export async function setStudentEmail(email, code) {
  const res = await instance.post(
    `${baseUrl}/student/setStudentEmail?email=${email}&code=${code}`
  );
  return res.data;
}
//学生修改密码
export async function studentChangePassword(password) {
  const res = await instance.post(
    `${baseUrl}/student/studentModifyPassword?pwd=${password}`
  );
  return res.data;
}
//验证学生信息
export async function verifyStudentInfo(verifydata) {
  const res = await instance.post(
    `${baseUrl}/student/verifyStudentInfo`,
    verifydata
  );
  return res.data;
}
//学生重置密码
export async function studentResetPassword(uid, password, code) {
  const res = await instance.post(
    `${baseUrl}/student/studentResetPassword?pwd=${password}&uId=${uid}&code=${code}`
  );
  return res.data;
}

// 获取我的公告列表
export async function getMyBulletin(params) {
  const res = await instance.get(`${baseUrl}/bulletin/myBulletin`, {
    params: params
  });
  return res.data;
}

// 获取公告详情
export async function myBulletinDetail(id) {
  const res = await instance.get(
    `${baseUrl}/bulletin/myBulletinDetail?id=${id}`
  );
  return res.data;
}

// 获取未读消息数量
export async function noReadCount() {
  const res = await instance.get(`${baseUrl}/bulletin/noReadCount`);
  return res.data;
}

// ==================== 附件上传相关 ====================

// 通用文件上传 (上传至云存储桶 - 腾讯云 COS)
export async function uploadFile(file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await instance.post(`${baseUrl}/aliyun/cosUploadFile`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
  return res.data;
}

// 添加试卷照片记录 (关联题目)
export async function addUserPaperPhotoRecord(data) {
  const res = await instance.post(
    `${baseUrl}/userResult/addUserPaperPhotoRecord`,
    data
  );
  return res.data;
}

// 修改试卷照片记录
export async function editUserPaperPhotoRecord(data) {
  const res = await instance.post(
    `${baseUrl}/userResult/editUserPaperPhotoRecord`,
    data
  );
  return res.data;
}

// 删除试卷照片记录
export async function delUserPaperPhotoRecord(recordID) {
  const res = await instance.post(
    `${baseUrl}/userResult/delUserPaperPhotoRecord?recordID=${recordID}`
  );
  return res.data;
}

// 获取学生试卷照片记录 (按试卷ID和题目ID)
export async function getUserPaperPhotoRecord(paperID, questionID, studentID) {
  let url = `${baseUrl}/userResult/getUserPaperPhotoRecord?paperID=${paperID}&questionID=${questionID}`;
  if (studentID) {
    url += `&studentID=${studentID}`;
  }
  const res = await instance.post(url);
  return res.data;
}


// 获取学生CMT能力测试试卷
export async function getStudentCmtExam() {
  const res = await instance.get(`${baseUrl}/examinationinfo/getStudentCmtExam`);
  return res.data;
}
